// extracted by mini-css-extract-plugin
module.exports = {"cardList":"CardList_cardList__msUui","table":"CardList_table__1Z0mF"};